
<template>
  <el-container class="errorIndex">
      <Header></Header>
      <el-main class="flex_justify_center">
          <p class="font_24_bold color_black">{{$t('global.error')}}<br /> {{$t('global.trtAgain')}}</p>
          <img src="../assets/Error.png" />
      </el-main>
  </el-container>
</template>
<script>
import Header from './header/header'
export default {
  components: {
    Header
  }
}
</script>
<style lang="less" scoped>
.el-container{
  display: block;
}
  .errorIndex{
    height: 100%;
    .el-header{
      height: 88px!important;
      background: rgba(53,54,67,0.90);
      width: 100%;
      padding:0;
    }
    .el-main{
      height: calc(100% - 83px);
      overflow: inherit;
      padding:0;
      flex-direction: column;
      p{
        margin-bottom:55px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/error.vue